import './style.scss'
import { EmployeeReportStatus, reportStatuses } from 'models'

type Props = {
  status: EmployeeReportStatus
}

export const ReportStatusIndicator = (props: Props) => {
  let classes = 'c-report-status-indicators__icon'

  switch (props.status) {
    case 'open':
      classes += ' s-open'
      break
    case 'waiting_for_approval':
      classes += ' s-waiting-for-approval'
      break
    case 'invoicing':
      classes += ' s-invoicing'
      break
    case 'closed':
      classes += ' s-closed'
      break
  }

  return (
    <div className={'c-report-status-indicators'}>
      <div className={classes}></div>
      <div>{reportStatuses.find((item) => item.key === props.status)?.secondary_value}</div>
    </div>
  )
}
